import ThongBaoSaiSotPage from "./ThongBaoSaiSotPage";

export default ThongBaoSaiSotPage